/** E-mail uit kandidaatrecord (kolom + ai_parsed_data), gelijk aan profielweergave. */
export function getCandidateEmail(
    candidate:
        | {
              email?: string | null;
              contact_email?: string | null;
              ai_parsed_data?: Record<string, unknown> | null;
          }
        | null
        | undefined,
): string {
    if (!candidate) return '';
    const parsed =
        candidate.ai_parsed_data && typeof candidate.ai_parsed_data === 'object'
            ? candidate.ai_parsed_data
            : {};
    const personal =
        parsed.personal_info && typeof parsed.personal_info === 'object'
            ? (parsed.personal_info as Record<string, unknown>)
            : {};
    const contactInfo =
        parsed.contact_info && typeof parsed.contact_info === 'object'
            ? (parsed.contact_info as Record<string, unknown>)
            : {};
    return String(
        candidate.email ||
            candidate.contact_email ||
            parsed.email ||
            personal.email ||
            contactInfo.email ||
            '',
    ).trim();
}
